import React, { useState } from 'react';
import { View } from 'react-native';
import MySquareButton from '../components/MySquareButton';
import { LocStr } from '../utils/Utils';
import { deleteDuplicatedFlowService, duplicateFlowService } from '../utils/DuplicateConfigurations';
import {
  action_bar,
  Configure_main_screen,
  getSubCategoryId,
  layout_str,
  menu_screen,
  Menu_str,
  must_have_one_service,
  Select_services_available,
  Upload_assets,
} from '../utils/DictionaryManagementUtils';
import BreakLine from '../components/PanelsComponents/General/BreakLine';
import ServicesMenu from '../components/PanelsComponents/General/ServicesMenu';
import { arrangeScreenInJson } from '../screens/ScreensOrdering';
import UploadLogoMenu from '../components/PanelsComponents/Upload/UploadLogoMenu';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import Title from '../components/PanelsComponents/Text/Title';
import RadioPanel from '../components/PanelsComponents/Buttons/RadioPanel';

const Panel_A03_Menu = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  language,
}) => {
  const myStyle = {
    serviceItem: {
      width: '100%',
      height: '100%',
      borderRadius: 8,
      justifyContent: 'center',
      alignItems: 'center',
    },
  };
  const { services } = globJSON.configurations;
  const { user_types } = globJSON.configurations.deliverables;
  const { menu } = services;
  const editTextList = globJSON.configurations.services.screens_ordering
    .filter((serviceKey) => globJSON.configurations.services[serviceKey].selected)
    .map((serviceKey) => `configurations/services/${serviceKey}/name`);

  const onValueChanged = (key, value) => {
    menu[key] = value;
    onConfigChanged();
  };
  const [draggingState, setDraggingState] = useState({
    nowDragging: false,
    defaultOrder: [],
  });
    // todo
  const [messagePopupState, setMessagePopupState] = useState({
    isMessageVisible: false,
    title: '',
  });
  const [deleteServicePopupState, setDeleteServicePopupState] = useState({
    isDeleteServiceVisible: false,
    service: null,
  });
  const [addServicePopupState, setAddServicePopupState] = useState({
    isAddServiceVisible: false,
    service: null,
  });
  const onStartEditOrderPressed = () => {
    setDraggingState({
      nowDragging: true,
      defaultOrder: [globJSON.configurations.services.screens_ordering],
    });
  };
  const onDuplicateFlowService = (item, newName) => {
    duplicateFlowService(globJSON, item, newName);
    arrangeScreenInJson(globJSON, onConfigChanged);
  };
  const onSaveEditOrderPressed = () => {
    arrangeScreenInJson(globJSON, onConfigChanged);
    setDraggingState({
      nowDragging: false,
      defaultOrder: [],
    });
  };
  const onCancelEditOrderPressed = () => {
    globJSON.configurations.services.screens_ordering = draggingState.defaultOrder;
    arrangeScreenInJson(globJSON, onConfigChanged);

    // setState({ ...state, select_services: [...draggingState.defaultOrder] });
    setDraggingState({
      nowDragging: true,
      defaultOrder: [...globJSON.configurations.services.screens_ordering],
    });
  };
  const onDeleteDuplicatedFlowService = (item) => {
    deleteDuplicatedFlowService(globJSON, item);
    arrangeScreenInJson(globJSON, onConfigChanged);
  };
  const render_item = ({ key: serviceKey }, index) => {
    const service = globJSON.configurations.services[serviceKey];

    return (
      <View style={myStyle.serviceItem} key={serviceKey + index}>
        <MySquareButton
          onServiceStateChanged={(value) => {
            onServiceStateChanged(service, value);
          }}
          value={service.selected}
          nowDragging={draggingState.nowDragging}
          title={service.name}
          language={language}
          service={service}
          onDuplicateFlowService={() => setAddServicePopupState({
            isAddServiceVisible: true,
            service,
          })}
          onDeleteDuplicatedFlowService={() => setDeleteServicePopupState({
            isDeleteServiceVisible: true,
            service,
          })}
          showDeleteButton={service.duplication_number !== 0}
        />
      </View>
    );
  };
  const onDragReleased = (newArray) => {
    globJSON.configurations.services.screens_ordering = newArray.map((item) => item.key);
    arrangeScreenInJson(globJSON, onConfigChanged);
  };
  const onServiceStateChanged = (service, value) => {
    if (!value && !globJSON.configurations.services.screens_ordering
      .some((serviceKey) => serviceKey !== getSubCategoryId(service) && globJSON.configurations.services[serviceKey].selected)) {
      const txt = LocStr(must_have_one_service, language);
      setMessagePopupState({
        isMessageVisible: true,
        title: txt,
      });
      return;
    }
    service.selected = value;
    if (!value) {
      arrangeUserTypeServiceInJson(service, user_types);
    }
    arrangeScreenInJson(globJSON, onConfigChanged);
  };
  const arrangeUserTypeServiceInJson = (service, userTypes) => {
    userTypes.userTypes.forEach((userType, userIndex) => {
      userType.services.forEach((item, serviceIndex) => {
        if (item === service.name) {
          userTypes.userTypes[userIndex].services.splice(serviceIndex, 1);
        }
      });
    });
  };
  const number_of_services = services.screens_ordering.filter((screen) => services[screen].selected).length;

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      panelHeadline={Menu_str}
      editTextList={editTextList}
      paragraph={Configure_main_screen}
      language={language}
      hideStepIndicator
      breakLineMarginTop={18}
      extraServiceLineHeight={Math.ceil(number_of_services / 3) - 2}
    >
      <Title isBold>{layout_str}</Title>
      <RadioPanel
        value={menu.layout_menu_screen}
        headlineLeftOption={menu_screen}
        headlineRightOption={action_bar}
        onPressLeftOption={() => onValueChanged('layout_menu_screen', true)}
        onPressRightOption={() => onValueChanged('layout_menu_screen', false)}
        paddingStart={0}
        language={language}
      />
      <BreakLine />

      <ServicesMenu
        globJSON={globJSON}
        headline={LocStr(Select_services_available, language)}
        state={globJSON.configurations.services.screens_ordering.map((serviceKey) => ({ key: serviceKey }))}
        renderItem={render_item}
        onDragReleased={onDragReleased}
        onSaveEditOrderPressed={onSaveEditOrderPressed}
        onCancelEditOrderPressed={onCancelEditOrderPressed}
        onStartEditOrderPressed={onStartEditOrderPressed}
        draggingState={draggingState.nowDragging}
        language={language}
        addServicePopupState={addServicePopupState}
        onDuplicateFlowService={onDuplicateFlowService}
        setAddServicePopupState={setAddServicePopupState}
        deleteServicePopupState={deleteServicePopupState}
        onDeleteDuplicatedFlowService={onDeleteDuplicatedFlowService}
        setDeleteServicePopupState={setDeleteServicePopupState}
      />
      <UploadLogoMenu
        globJSON={globJSON}
        onConfigChanged={onConfigChanged}
        setMessagePopupState={setMessagePopupState}
        headline={LocStr(Upload_assets, language)}
        onValueChanged={onValueChanged}
        language={language}
      />
    </FullPagePanel>
  );
};

export default Panel_A03_Menu;
